import { useMemo } from 'react';
import Dagre from 'dagre';

function filterCollapsedChildren(
    dagreGraph,
    node
) {
    const children = dagreGraph.successors(node.id) || [];
    node.data.expandable = children.length > 0;

    if (!node.data.expanded) {
        while (children.length) {
            const child = children.pop();
            children.push(...(dagreGraph.successors(child) || []));
            dagreGraph.removeNode(child);
        }
    }
}

function useExpandCollapse(
    nodes,
    edges,
    {
        layoutNodes = true,
        treeWidth = 200,
        treeHeight = 100,
    } = {}
) {
    return useMemo(() => {
        // if (!layoutNodes) return { nodes, edges };

        let workingNodes = nodes.map((n) => ({ ...n, data: { ...n.data } }));
        // let workingEdges = edges.map((e) => ({ ...e }));

        const dagreGraph = new Dagre.graphlib.Graph()
            .setDefaultEdgeLabel(() => ({}))
            .setGraph({ rankdir: 'LR' });

        workingNodes.forEach((node) => {
            dagreGraph.setNode(node.id, {
                width: treeWidth,
                height: treeHeight,
                data: node.data,
            });
        });

        edges.forEach((edge) => {
            dagreGraph.setEdge(edge.source, edge.target);
        });

        // workingEdges.forEach((edge) => {
        //     dagreGraph.setEdge(edge.source, edge.target);
        // });

        workingNodes.forEach((node) => {
            filterCollapsedChildren(dagreGraph, node);
        });

        // Run the dagre layouting algorithm.
        Dagre.layout(dagreGraph);

        const layoutedNodes = workingNodes.flatMap((node) => {
            if (!dagreGraph.hasNode(node.id)) {
                return [];
            }
            const { x, y } = dagreGraph.node(node.id);
            const data = { ...node.data }; // clone data เพื่อ React ตรวจเจอการเปลี่ยนแปลง
            return [{ ...node, position: { x, y }, data }];
        });

        return { nodes: layoutedNodes, edges };
        // return { nodes: layoutedNodes, edges: workingEdges };
    }, [nodes, edges, layoutNodes, treeWidth, treeHeight]);
}

export default useExpandCollapse;
